import { useRollbar as useRollbarBase } from '@rollbar/react';
import type Rollbar from 'rollbar';

import { config } from './config';
import { rollbar } from './rollbar';

const hasToken = Boolean(import.meta.env.VITE_ROLLBAR_TOKEN);

function logMock(level: string, ...args: unknown[]): void {
    // oxlint-disable-next-line no-console
    console.warn(`[Rollbar mock] ${level}:`, ...args);
}

const devMock: Rollbar = {
    error: (...args: unknown[]) => logMock('error', ...args),
    critical: (...args: unknown[]) => logMock('critical', ...args),
    warning: (...args: unknown[]) => logMock('warning', ...args),
    info: (...args: unknown[]) => logMock('info', ...args),
    log: (...args: unknown[]) => logMock('log', ...args),
    debug: (...args: unknown[]) => logMock('debug', ...args),
} as unknown as Rollbar;

// Non-hook Rollbar client for use outside React components (e.g. QueryClient).
export const rollbarClient: Rollbar = hasToken && !config.isDevMode ? rollbar : devMock;

export function useRollbar(): Rollbar {
    const instance = useRollbarBase();
    return hasToken && !config.isDevMode ? instance : devMock;
}
